"use strict";

exports.__esModule = true;
exports.default = void 0;
// BRIGHTHR Brand Palette
var BLUE1 = '#1784FF'; // Dark

var BLUE2 = '#3DB0F7'; // Base

var BLUE3 = '#A2DBFF'; // Light

var BLUE4 = '#D0EBFD'; // Lighter

var BLUE5 = '#F2FAFF'; // Lightest
// 2019 branding blue palette colours

var BLUE9 = '#0057AD'; // Intended for clickable UI elements

var BLUE10 = '#0070E0'; // clickable UI hover/focus

var BLUE11 = '#3399FF'; // clicable UI active

var PINK1 = '#AD005C'; // Dark

var PINK2 = '#E10078'; // Base

var PINK3 = '#F978B3'; // Light

var PINK4 = '#FFC9E5'; // Lighter

var WHITE = '#FFF';
var GREY1 = '#333'; // Darkest

var GREY2 = '#737980'; // Dark

var GREY3 = '#A1A9B3'; // Base

var GREY4 = '#CED3D9'; // Light

var GREY5 = '#F5F7FA'; // Lighter

var GREY6 = '#e8eaec'; // Pale
// new ui state colours

var GREEN2 = 'hsla(150,82%,19%,1)';
var GREY9 = 'hsla(205,67%,12%,1)';
var RED2 = 'hsla(340,100%,32%,1)';
var GREEN3 = 'hsla(150,100%,90%,1)';
var GREY10 = 'hsla(205,32%,88%,1)';
var RED3 = 'hsla(340,100%,97%,1)'; // Non-brand system/ui state colours

var GREEN = '#3DCC85';
var DEEPGREEN = '#7DAFA3';
var ORANGE = '#FF5000';
var RED = '#D75863';
var GOLD = '#E0AE2E';
var YELLOW = '#ffc107';
var PURPLE = '#86507d';
var LIGHTPURPLE = '#84A5BF';
var SALMON = '#FF9D78';
var LIGHT_YELLOW = '#FFEFD4';
var APRICOT = '#F07263';
var BLUE6 = '#70C4F9'; // absence colour (annual leave)

var BLUE7 = '#EAF6FD'; // highlight colour

var BLUE8 = '#36637D'; // absence colour (protected)
// Non-brand other

var SHADOW1 = 'hsla(0, 0%, 0%, 0.25)'; // Standard box-shadow colour

var SHADOW2 = 'hsla(0, 0%, 0%, 0.75)'; // Standard box-shadow colour

var SHADOW3 = 'hsla(0, 0%, 0%, 0.5)'; // Standard box-shadow colour

var OVERLAY = 'hsla(212, 35%, 25%, 0.75)'; // Modal overlay colour

var colors = {
  positive: GREEN2,
  neutral: GREY9,
  negative: RED2,
  positiveBackground: GREEN3,
  neutralBackground: GREY10,
  negativeBackground: RED3,
  primaryDark: BLUE1,
  primaryDarker: BLUE9,
  primary: BLUE2,
  primaryLight: BLUE3,
  primaryLighter: BLUE4,
  secondaryDark: PINK1,
  secondary: PINK2,
  secondaryLight: PINK3,
  secondaryLighter: PINK4,
  greyDarker: GREY1,
  greyDark: GREY2,
  grey: GREY3,
  greyLight: GREY4,
  greyLighter: GREY5,
  greyPale: GREY6,
  outlineHover: GREY4,
  iconColor: GREY1,
  borderColor: GREY3,
  borderFocus: BLUE2,
  borderError: ORANGE,
  link: BLUE9,
  linkHover: BLUE10,
  linkFocus: BLUE10,
  linkActive: BLUE11,
  error: ORANGE,
  warning: YELLOW,
  success: GREEN,
  tileOverlay: 'hsla(0, 0%, 100%, .8)',
  textColor: GREY1,
  mutedTextColor: GREY3,
  disabled: GREY3,
  disabledBackground: GREY5,
  disabledOutline: GREY4,
  placeholder: GREY3,
  white: WHITE,
  shadow: SHADOW1,
  modalShadow: SHADOW2,
  employeeCardShadow: SHADOW3,
  modalOverlay: OVERLAY,
  focusBackground: WHITE,
  focusBorder: BLUE2,
  focusColor: GREY1,
  bodyBackground: BLUE5,
  highlight: BLUE7,
  absences: {
    ANNUAL_LEAVE: BLUE6,
    LATENESS: RED,
    SICKNESS: GOLD,
    TOIL: SALMON,
    OTHER: DEEPGREEN,
    BANK_HOLIDAY: PURPLE,
    PUBLIC_HOLIDAY: PURPLE,
    NOTABLE_DATE: LIGHTPURPLE,
    PROTECTED: BLUE8,
    FURLOUGH: APRICOT
  },
  snackbar: {
    BASIC: WHITE,
    INFORMATION: GREY1,
    SUCCESS: BLUE2,
    ERROR: ORANGE
  },
  info: LIGHT_YELLOW
};
/** @component */

var _default = colors;
exports.default = _default;